<template>
  <div class="ui_hotelFilter" v-show='isShowDialog'>
    <div class="searchTop">
      <!-- <i class="icon iconfont icon-jiantou" @click='hideDialog()'></i> -->
      <input type="text" id="search-query" :placeholder="placeholder" v-model.lazy="searchVal" class='searchQuery'>
      <p class="cancel" @click="hideDialog()">取消</p>
    </div>
    <div class="searchShow" v-show="searchVal.length>0">
      <ul>
        <li v-for="(hotel,hotelIndex) in hotels" @click="goHotelSearch(hotel)" :key='hotelIndex'>
          <p class="address">{{hotel.descript}}</p>
        </li>
        <li v-for="(add,addIndex) in address" @click="goAddress(add)" :key='addIndex'>
          <p class="address">{{add.address}}</p>
        </li>
        <div class="noResult" v-show="hotels.length==0&&address.length==0">无结果</div>
      </ul>
    </div>
    <div class="hotelFilterBox">
      <div class="hotelFilterItem" v-for="(searchItemList,searchItemListIndex) in searchList" :key='searchItemListIndex'>
        <p class="hotelFilterTitle">{{searchItemList.descript}}</p>
        <ul class="hotelFilterList">
          <li class="filterItem" v-for="(searchItem,searchItemIndex) in searchItemList.children" :key='searchItemIndex' @click='chooseItem(searchItem,searchItemList)' v-bind:class="{ 'active' : searchItem.state}"><em>{{searchItem.descript}}</em></li>
        </ul>
      </div>
    </div>
    <a class="hotelFilterSure" @click="search">确定</a>
    <!-- <div class="otherShow clearfix">
      <div class="leftType">
        <ul>
          <li v-for="(type2,tpye2Index) in leftType"  v-bind:class="{ 'active' : type2.state}" @click="toggle(type2)" :key='tpye2Index'>
            {{type2.descript}}
          </li>
        </ul>
      </div>
      <div class="showDistrict">
        <div class="typeContent">
          <div>
            <ul>
              <li v-for="(item,itemIndex) in rightType"  v-bind:class="{ 'checked':item.state}" @click="toggleNext(item)" :key='itemIndex'>
                <span class="ovh">{{item.descript}}</span>
                <i class="icon iconfont icon-shangwugouxuan" v-if='item.state'></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="sureContent">
        <p class="reset canReset" @click="restore" v-if="positionValue!=''">重置</p>
        <p class="reset"  v-else >重置</p>
        <p class="home sureIt" id="selectedAll" @click="search" >确定</p>
    </div> -->
  </div>
</template>

<script>
import { jAlert3 } from "@/base/jAlert/jAlert";
import api from "@/utils/api";
import { urlEncode } from "@/utils/index";
import { setStorage , getStorage} from "@/utils/wxuser";

var config = {};
export default {
  props: ["cityCode", "cityName", "otaChannel", "fromDate", "toDate","placeholder","distributorId"],
  data() {
    return {
      isShowDialog: false,
      firstCode: "",
      searchVal: "",
      address: [],
      hotels: [],
      leftType: [],
      rightType: [],
      position: "",
      positionValue: "",
      keyWord: "",
      radius: "300000",
      positionDescript: "",
      clientLatitude: "",
      clientLongitude: "",
      searchList:[],
      hasAddress:"F",
      isAssociation:this.$route.query.isAssociation||"",
      companyCode:this.$route.query.companyCode||"",
      companyDesc: this.$route.query.companyDesc || "",
      salesMan:this.$route.query.salesMan||"",
      salesName:this.$route.query.salesName||"",
      rsvManNo: this.$route.query.rsvManNo || "",
      rsvManName: this.$route.query.rsvManName || "",
      isCompanyBook: this.$route.query.isCompanyBook || "F",
      isBuyOnBehalf: this.$route.query.isBuyOnBehalf || "",
    };
  },
  mounted() {},
  created() {
    config = getStorage("config");
  },
  beforeDestroy() {
    this.isShowDialog = false;
  },
  methods: {
    chooseItem(item,parent){
      if(!item.state){
        this.searchList.forEach((n,i)=>{
          n.children.forEach((m,j)=>{
            m.state = false;
          })
        })
      }
      item.state = !item.state;
      if(item.state){
        this.positionValue = item.code;
        this.positionDescript = item.descript;
        this.position = parent.code;
        this.hasAddress = "T";
      }else{
        this.position = "";
        this.positionValue = "";
        this.positionDescript = "";
        this.hasAddress = "F";
      }
    },
    showDialog() {
      this.isShowDialog = true;
      this.$emit("no-scroll", true);
    },
    hideDialog() {
      this.isShowDialog = false;
      this.$emit("no-scroll", false);
    },
    changeCityAdvancedSearch() {
      this.initAdvancedSearch();
      this.clear();
    },
    initAdvancedSearch() {
      if (!this.cityCode) {
        return false;
      }
      var self = this;
      api.getAdvancedSearch({
        city: self.cityCode,
        type: "4",
        parentCode: "",
        hotelGroupCode: config.hotelGroupCode
      }).then(data => {
        self.searchList = [];
        if (data.result == 1) {
          for (let i = 0; i < data.retVal.length; i++) {
            var code = data.retVal[i].code;
            api.getAdvancedSearch({
              city: self.cityCode,
              type: "4",
              parentCode: code,
              hotelGroupCode: config.hotelGroupCode
            }).then(res => {
              if (res.result == 1) {
                res.retVal.forEach(function(n,i){
                  n.state = false;
                })
                data.retVal[i].children = res.retVal;
              } else {
                data.retVal[i].children = [];
              }
              self.searchList.push(data.retVal[i])
            });
          }
          /*console.log(data.retVal)
          self.searchList = data.retVal;*/
        }else{
          jAlert3("加载信息失败!");
        };
      })
    },
    search: function() {
      var self = this;
      /*if (this.positionDescript == "") {
        this.hasAddress = "F";
      }else{
        this.hasAddress = "T";
      }*/
      var obj = {
        position: self.position,
        positionValue: self.positionValue,
        keyWord: self.keyWord,
        radius: "300000",
        positionDescript: self.positionDescript,
        hasAddress: this.hasAddress,
        clientLatitude: self.clientLatitude,
        clientLongitude: self.clientLongitude
      };
      this.hideDialog();
      this.$emit("shaiXuanSearch", obj);
    },
    clear: function() {
      this.searchVal = "";
      this.position = "";
      this.positionValue = "";
      this.keyWord = "";
      this.positionDescript = "";
      this.hasAddress = "F";
      this.clientLatitude = "";
      this.clientLongitude = "";
      var obj = {
        position: this.position,
        positionValue: this.positionValue,
        keyWord: this.keyWord,
        radius: "300000",
        positionDescript: this.positionDescript,
        hasAddress: this.hasAddress,
        clientLatitude: this.clientLatitude,
        clientLongitude: this.clientLongitude
      };
      this.$emit("shaiXuanSearch", obj);
    },
    searchPosition: function() {
      var self = this;
      api
        .placeSearch({
          keyword: self.searchVal,
          boundary: self.cityName,
          orderby: "_distance",
          page_size: "15",
          page_index: "1"
        })
        .then(res => {
          var res = JSON.parse(res);
          console.log(res)
          self.address = res.data;
        });
    },
    searchHotel: function() {
      var self = this;
      api
        .findHotel({
          fromDate: self.fromDate,
          toDate: self.toDate,
          otaChannel: "wechat",
          hotelGroupCodes: config.hotelGroupCode,
          city: self.cityCode,
          keyWord: self.searchVal,
          appid:config.appid,
          componentAppid:config.componentAppid
        })
        .then(function(response) {
          if (response.result == 1) {
            self.hotels = response.retVal.resultInfos;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    goHotelSearch: function(item) {
      var params = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        hotelCode: item.code,
        hotelGroupCode:item.hotelGroupCode,
        distributorId:this.distributorId||"",
        otaChannel:this.otaChannel||"WECHAT",
        isAssociation:this.isAssociation,
        companyCode:this.companyCode,
        salesMan:this.salesMan,
        salesName:this.salesName,
        companyDesc:this.companyDesc,
        rsvManNo:this.rsvManNo,
        rsvManName:this.rsvManName,
        isCompanyBook:this.isCompanyBook,
        isBuyOnBehalf:this.isBuyOnBehalf,
      };
      /* this.$router.push({
        path: "/hotel",
        name: "hotel",
        query: params
      }); */
      window.location.href = `${window.location.origin}/wechat/#/hotel?${urlEncode(params)}`
      /*wx.navigateTo({
        url: "/pages/order/hotel?" + urlEncode(params)
      });*/
    },
    goAddress: function(item) {
      var obj = {
        position: "",
        positionValue: "",
        keyWord: "",
        radius: "",
        hasAddress: "T",
        clientLatitude: item.lat,
        clientLongitude: item.lng,
        positionDescript: item.address
      };
      this.$emit("shaiXuanSearch", obj);
      this.hideDialog();
    }
  },
  watch: {
    searchVal: function(val, oldVal) {
      if (val == "") {
        this.address = [];
        this.hotels = [];
      } else {
        this.searchPosition();
        this.searchHotel();
      }
    },
    cityCode: function(val, oldVal) {
      this.changeCityAdvancedSearch();
    }
  }
};
</script>
<style lang="less">
@import url("~@/styles/skin.less");
@import url("~@/styles/mixin.less");
.ui_hotelFilter {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  min-height: 100vh;
  z-index: 99;
  background: @color-background-d;
  max-height: 100vh;
  overflow-y: scroll;
  .hotelFilterSure{
    width: calc(~"100vw - 24px");
    position:fixed;
    left: 12px;
    bottom:10px;
    height: 44px;
    color: #fff;
    line-height: 44px;
    text-align: center;
    background: @color-theme;
    box-shadow: @color-shadow;
    border-radius: @border-small;
  }
  .hotelFilterBox{
    height: calc(~"100vh - 110px");
    overflow-y: scroll;
    padding:0 20px;
    .hotelFilterItem{
      margin-top: 10px;
      .hotelFilterTitle{
        font-size: @font-size-medium-x;
        color: @color-font;
        margin-bottom: 20px;
      }
      .hotelFilterList{
        &::after{
          display: block;
          height: 0;
          clear: both;
          content: '';
        }
        .filterItem{
          background: @color-background;
          box-shadow: @color-shadow;
          border-radius: @border-small;
          height: 40px;
          width: 100px;
          display: flex;
          align-items:center;
          justify-content: center;
          float: left;
          font-size: @font-size-medium;
          color: @color-font;
          margin-right: 10px;
          margin-bottom: 10px;
          em{
            overflow:hidden; 
            text-overflow:ellipsis;
            display:-webkit-box; 
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2; 
            font-size: @font-size-small-s;
            padding:0 5px;
          }
          &:nth-child(3n+0){
            margin-right: 0px;
          }
          &.active{
            color:#fff;
            background:@color-theme;
          }
        }
      }
    }
  }
  .searchTop {
    background: @color-background;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    height: 44px;
    display: flex;
    align-items: center;
    padding: 6px 16px;
    box-sizing: border-box;
    padding-left: 0px;
    .icon-jiantou {
      transform: scaleX(-1);
      color: @color-font;
      font-size: 14px;
      /* margin-right: 10px; */
      font-weight: normal;
      position: relative;
      border: 10px solid transparent;
      background-clip: padding-box;
    }
    .searchQuery {
      background: @color-background-s;
      border-radius: 4px;
      border: none;
      line-height:30px;
      height: 30px;
      font-size: @font-size-medium-x;
      flex: 1;
      padding-left: 12px;
      height: 32px;
      line-height: 32px;
      font-size: @font-size-medium;
      color: @color-font-d;
    }
    .cancel{
      font-size: 16px;
      color: #333;
      margin-left: 9px;
    }
  }
  .searchShow {
    z-index: 10;
    position: absolute;
    width: 100%;
    background: @color-background-d;
    height: 100%;
    overflow-y: scroll;
    ul {
      li {
        height: 50px;
        line-height: 50px;
        box-sizing: border-box;
        padding: 0 20px;
        p {
          font-size: @font-size-medium-x;
          color: @color-font;
          .textHidden();
        }
      }
      .noResult {
        text-align: center;
        font-size: @font-size-medium-x;
        color: @color-font;
        margin: 20px 0;
      }
    }
  }
  .otherShow {
    overflow-y: scroll;
    height: calc(~"100vh - 84px");
    display: flex;
    .leftType {
      height: 100%;
      width: 108px;
      ul {
        li {
          height: 48px;
          line-height: 48px;
          width: 100%;
          text-align: center;
          font-size: @font-size-medium-x;
          color: #888888;
          &.active {
            color: #eee;
            background: @color-background;
          }
        }
      }
    }
    .showDistrict {
      flex: 1;
      .typeContent {
        div {
          ul {
            li {
              padding: 0 25px;
              width: 100%;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              box-sizing: border-box;
              .ovh {
                font-size: 15px;
                color: #cccccc;
              }
              &.checked {
                .ovh {
                  color: @color-theme;
                }
              }
              .icon-shangwugouxuan {
                color: @color-theme;
              }
            }
          }
        }
      }
    }
  }
  .sureContent {
    position: fixed;
    bottom: 0px;
    left: 0;
    width: 100vh;
    display: flex;
    align-items: center;
    height: 40px;
    .reset {
      height: 100%;
      background: @color-theme-d;
      font-size: @font-size-large;
      color: #fff;
      width: 160px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sureIt {
      height: 100%;
      width: calc(~"100vw - 160px");
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-theme;
      font-size: 16px;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/hotelFilter/hotelFilter.vue